<template>
    <div class="vx-row vx-card pt-4">
        <div class="vx-col w-full">
            <vs-tabs v-model="activeTab">
                <vs-tab :label="$t('dashboard.employeeShifts')"  icon-pack="feather" icon="icon-user">
                    <div class="w-full">
                        <work-shift-employee />
                    </div>
                </vs-tab>
                <vs-tab :label="$t('dashboard.teachingShift')" icon-pack="feather" icon="icon-user">
                    <div class="w-full">
                        <work-shift-teacher />
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>

<script>
import WorkShiftTeacher from '../school-schedule/TeachingScheduleManager.vue'
import WorkShiftEmployee from '../school-schedule/StaffScheduleManager.vue'
export default {
    components:{
        WorkShiftTeacher,
        WorkShiftEmployee
    },
    data(){
        return {
            activeTab: 0
        }
    }
}
</script>

<style>

</style>
